import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { toast } from 'sonner'
import { AuthLayout } from '@/layout/AuthLayout'

export function ConfirmSignUp() {
  const [code, setCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { confirmSignUp } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const username = location.state?.username

  if (!username) {
    navigate('/auth/signup')
    return null
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      await confirmSignUp(username, code)
      toast.success('Account confirmed successfully!')
      navigate('/auth/signin')
    } catch (error) {
      toast.error(
        'Failed to confirm account. Please check the code and try again.',
      )
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthLayout>
      <Card className="border-0 shadow-none">
        <CardHeader className="pb-4">
          <CardTitle className="text-2xl py-4">Confirm Your Account</CardTitle>
          <CardDescription className="text-xs text-slate-600 dark:text-slate-400">
            Enter the verification code sent to your email
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-0">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Input
                id="code"
                type="text"
                value={code}
                onChange={e => setCode(e.target.value)}
                required
                placeholder="Enter the 6-digit code"
                className="rounded-xl shadow-xl"
              />
            </div>
            <Button
              type="submit"
              className="w-full rounded-xl shadow-xl mt-4"
              disabled={isLoading}
            >
              {isLoading ? 'Confirming...' : 'Confirm Account'}
            </Button>
          </form>
        </CardContent>
        <CardFooter className="pt-4">
          <div className="text-xs text-slate-600 dark:text-slate-400">
            Didn't receive the code?{' '}
            <Button
              variant="link"
              className="p-0 h-auto text-xs text-blue-700 hover:underline dark:text-blue-400"
              onClick={() => navigate('/auth/signup')}
            >
              Sign up again
            </Button>
          </div>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}
